function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M383.72,311.738l-6.325-6.324a1.368,1.368,0,0,0-.975-.414H362.389A1.4,1.4,0,0,0,361,306.389v22.092a1.4,1.4,0,0,0,1.389,1.389h8.822v6.391a1.39,1.39,0,0,0,2.778.067v-6.451h8.822a1.325,1.325,0,0,0,1.322-1.322V312.713a1.341,1.341,0,0,0-.414-.975Zm-5.837-2.037,2.625,2.6h-2.625Zm3.613,17.464H374v-5.53l1.182,1.089a1.381,1.381,0,0,0,1.877-.067,1.4,1.4,0,0,0-.067-1.944l-3.473-3.2a1.385,1.385,0,0,0-1.877,0l-3.473,3.2a1.375,1.375,0,1,0,1.877,2.01l1.182-1.089v5.53h-7.44V307.778h11.326v5.763a1.4,1.4,0,0,0,1.389,1.389h5v12.235Zm0,0",
  transform: "translate(-360.75 -304.75)",
  strokeWidth: 0.5
});

function SvgFileUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.634,
    height: 33.151,
    viewBox: "0 0 23.634 33.151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file-upload-icon.c0a9907e.svg";
export { ForwardRef as ReactComponent };